import { AlarmReporterIdentityType } from 'shared/components/alarm-card/enums/alarm-reporter-identity-type';
import { AlarmType } from 'shared/components/alarm-card/enums/alarm-type';

export type AlarmCardProps = {
  type: AlarmType;
  isAssistanceType: boolean;
  reporterIdentityType: string;
  reportedByFullName: string;
  organisationUnitName: string;
  descendantOrganisationUnitNames: string[];
};

type AlarmCard = {
  isGenericOrEmergency: boolean;
  getOrganisationUnitPrefix: (t: (key: string) => string) => string;
  getOrganisationUnitName: () => string;
};

export const useAlarmCard = ({
  type,
  isAssistanceType,
  reporterIdentityType,
  reportedByFullName,
  organisationUnitName,
  descendantOrganisationUnitNames,
}: AlarmCardProps): AlarmCard => {
  const isGenericOrEmergency = type === AlarmType.GenericCall || type === AlarmType.Emergency;

  const getOrganisationUnitPrefix = (t: (key: string) => string): string => {
    if (isAssistanceType) {
      return reporterIdentityType === AlarmReporterIdentityType.User && reportedByFullName !== ''
        ? reportedByFullName
        : t('colleaguePrefix');
    }
    return t('residentPrefix');
  };

  const getOrganisationUnitName = (): string => {
    if (descendantOrganisationUnitNames.length > 0) {
      return `${organisationUnitName}, ${descendantOrganisationUnitNames.join(', ')}`;
    }
    return organisationUnitName;
  };

  return {
    isGenericOrEmergency,
    getOrganisationUnitPrefix,
    getOrganisationUnitName,
  };
};
